import React from "react";
import ICON from "../icons.js";
import { safeUrl, websiteUrl, facebookUrl } from "../../../components/sale-format.js";
import { stripJuristic } from "../../../components/text-sanitize.js";

/* ============================================================================
 * HomeFooter — แบรนด์ + ช่องทางติดตาม + ข้อมูลติดต่อ
 *
 * ปิดท้ายหน้าเว็บ · ข้อความและช่องทางแก้ได้จากหลังบ้าน
 * (section "footer" = ข้อความ, section "social" = ช่องทางติดตาม)
 *
 * ★ ลิงก์ทุกอันที่มาจากผู้ดูแลผ่าน safeUrl — รับเฉพาะ http(s)/tel/mailto/line
 *   ลิงก์โซเชียลที่ไม่ผ่านไม่แสดงเลย (ไม่ใส่ href="#" หลอกให้กดแล้วไม่เกิดอะไร)
 * ★ faqHref : หน้าที่ไม่มีบล็อกคำถาม (เช่น /room) ส่งลิงก์ไปหน้ารวมของโครงการแทน #hm-faq
 * ========================================================================== */
export default function HomeFooter({ content, setting = {}, socials = [], projects = [], faqs = [], faqHref = "#hm-faq" }) {
    const year = new Date().getFullYear() + 543; // แสดงเป็น พ.ศ. ตามเอกสารไทย
    const website = websiteUrl(setting.website);
    const facebook = facebookUrl(setting.facebook);
    const socialLinks = socials.map((item) => ({ ...item, href: safeUrl(item.link_url) })).filter((item) => item.href);

    return (
        <footer className="hm-footer" id="hm-footer">
            <div className="hm-container">
                <div className="hm-footer__grid">
                    <div className="hm-on-dark">
                        <div style={{ fontSize: 20, fontWeight: 700 }}>
                            {setting.logo_url ? (
                                <img src={setting.logo_url} alt="" loading="lazy" decoding="async" style={{ height: 36, objectFit: "contain", marginRight: 8 }} />
                            ) : (
                                <span className="hm-ico">{ICON.building}</span>
                            )}{" "}
                            {setting.company_name_th || "ห้องประกาศขาย/ให้เช่า"}
                        </div>
                        {!!setting.company_name_en && (
                            <div className="hm-footer__brand-desc" style={{ marginBottom: 4 }}>{setting.company_name_en}</div>
                        )}
                        <p className="hm-footer__brand-desc">
                            {setting.address || content?.body || "ตรวจสอบสถานะห้องได้จริงทุกห้อง"}
                        </p>
                        {/* เลขภาษี/ใบอนุญาต ต้องแสดงตามข้อกำหนดของนายหน้าอสังหาฯ */}
                        {!!setting.tax_number && (
                            <div className="hm-footer__brand-desc">เลขประจำตัวผู้เสียภาษี {setting.tax_number}</div>
                        )}
                        {!!setting.license_number && (
                            <div className="hm-footer__brand-desc">ใบอนุญาตนายหน้า {setting.license_number}</div>
                        )}
                    </div>

                    {!!projects.length && (
                        <div>
                            <div className="hm-footer__title">โครงการ</div>
                            <ul className="hm-footer__list">
                                {projects.map((p) => (
                                    <li key={p.project_id}>
                                        <a href={`/overview?project=${encodeURIComponent(p.project_id)}`}>{stripJuristic(p.project_name)}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {!!faqs.length && (
                        <div>
                            <div className="hm-footer__title">คำถามที่พบบ่อย</div>
                            <ul className="hm-footer__list">
                                {faqs.slice(0, 5).map((item) => (
                                    <li key={item.uid}>
                                        <a href={faqHref}>{item.title}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {!!socialLinks.length && (
                        <div>
                            <div className="hm-footer__title">ติดตามเรา</div>
                            <div className="hm-footer__social">
                                {socialLinks.map((item) => (
                                    <a key={item.uid} href={item.href} target="_blank" rel="noreferrer" aria-label={item.title || "โซเชียล"}>
                                        <span className="hm-ico">{item.icon || ICON.globe}</span>
                                    </a>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                <div className="hm-footer__bottom">
                    <div>© {year} {setting.company_name_th || content?.title || "ห้องประกาศขาย/ให้เช่า"}. สงวนลิขสิทธิ์</div>
                    <div className="hm-footer__bottom-links">
                        {/* ★ เว็บไซต์ที่กรอกไม่มี http (www.abc.co.th) เติม https:// ให้ ไม่งั้นกลายเป็นลิงก์ภายในเว็บเรา */}
                        {!!website && (
                            <a href={website} target="_blank" rel="noreferrer">{setting.website}</a>
                        )}
                        {!!facebook && (
                            <a href={facebook} target="_blank" rel="noreferrer">
                                {setting.facebook}
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </footer>
    );
}
